import type { ReactNode } from 'react';

import { EVENT_TYPE_COLORS } from '@/store/events/events.dto';

import styles from './EventHeader.module.scss';

interface EventHeaderProps {
  type: keyof typeof EVENT_TYPE_COLORS;
  title: string;
  fontFamily?: string;
  fontSize?: string;
  icon?: ReactNode;
}

export const EventHeader = ({ type, title, fontFamily, fontSize, icon }: EventHeaderProps) => {
  const additionalStyles = {
    fontFamily: fontFamily || 'inherit',
    fontSize: fontSize || 'inherit',
  };

  return (
    <div className={styles.eventHeader}>
      {icon ?? (
        <span
          className={`${styles.dot}`}
          style={{ backgroundColor: EVENT_TYPE_COLORS[type] ?? 'var(--accent-details-2)' }}
        />
      )}
      <span className={styles.eventTitle} style={additionalStyles}>
        {title}
      </span>
    </div>
  );
};
